export default [
  {
    path: '/data-order',
    name: 'data-order',
    component: () => import('@/views/pages/komship/order/DataOrder/Index.vue'),
    meta: {
      name: 'data-order',
      resource: 'Order',
      routeDetail: 'detail-order',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Data Order',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data-order/detail-order/:order_id',
    name: 'detail-order',
    component: () => import('@/views/pages/komship/order/DataOrder/DetailOrder.vue'),
    meta: {
      navActiveLink: 'data-order',
      editOrder: 'edit-order',
      routeToDataOrder: 'data-order',
      name: 'detail-order',
      resource: 'Order',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Detail Order',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-order',
    name: 'add-order',
    component: () => import('@/views/pages/komship/order/AddOrder'),
    meta: {
      name: 'add-order',
      resource: 'Order',
      routeToAddProduct: 'add-produk',
      routeToAddressSetting: 'gudangku',
      routeDetail: 'detail-add-order',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Add Order',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-cross-border-order',
    name: 'cross-border',
    component: () => import('@/views/pages/komship/order/CrossBorders'),
    meta: {
      navActiveLink: 'order',
      resource: 'Order',
      action: 'manage',
    },
  },
  {
    path: '/add-order-onboarding',
    name: 'add-order-onboarding',
    component: () => import('@/views/pages/komship/onboarding/AddOrder.vue'),
    meta: {
      name: 'add-order-onboarding',
      resource: 'Order',
      routeDetail: 'detail-add-order-onboarding',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Add Order Onboarding',
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-order-onboarding/detail-checkout',
    name: 'detail-add-order-onboarding',
    component: () => import('@/views/pages/komship/onboarding/Refactor/AddDetailOrder.vue'),
    meta: {
      resource: 'Order',
      action: 'manage',
      breadcrumb: [
        {
          text: 'Add Order Onboarding',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data-order/detail-order/edit/:order_id',
    name: 'edit-order',
    component: () => import('@/views/pages/komship/order/EditOrder/EditOrder.vue'),
    meta: {
      navActiveLink: 'data-order',
      resource: 'Order',
      action: 'manage',
    },
  },
  {
    path: '/method-order',
    name: 'method-order',
    component: () => import('@/views/pages/komship/order/MethodOrder'),
    meta: {
      navActiveLink: 'order',
      resource: 'Order',
      action: 'manage',
    },
  },
  {
    path: '/add-order-massal',
    name: 'add-order-massal',
    component: () => import('@/views/pages/komship/order/OrderMassal-V2/OrderMassal-V2.vue'),
    meta: {
      navActiveLink: 'order',
      resource: 'Order',
      action: 'manage',
    },
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('@/views/pages/komship/order/index.vue'),
    meta: {
      resource: 'Order',
      navActiveLink: 'add-order',
      action: 'manage',
    },
  },
  {
    path: '/data-order/paket-bermasalah/:id',
    name: 'data-order-trouble-helper',
    component: () => import('@/views/pages/komship/order/DataOrder/TroubleHelper/trouble-helper.vue'),
    meta: {
      resource: 'Order',
      navActiveLink: 'data-order',
      action: 'manage',
    },
  },
  {
    path: '/data-order/pengajuan-order',
    name: 'pengajuan-order',
    component: () => import('@/views/pages/komship/order/DataOrder/OrderSubmission/OrderSubmission.vue'),
    meta: {
      resource: 'Order',
      navActiveLink: 'data-order',
      action: 'manage',
    },
  },
  {
    path: '/data-order/insight-pengiriman',
    name: 'insight-pengiriman',
    component: () => import('@/views/pages/komship/order/InsightPengiriman/Insight.vue'),
    meta: {
      resource: 'Order',
      navActiveLink: 'insight',
      action: 'manage',
    },
  },
  {
    path: '/data-order/insight-pengiriman/order-dikirim',
    name: 'order-dikirim',
    component: () => import('@/views/pages/komship/order/InsightPengiriman/OrderChart.vue'),
    meta: {
      resource: 'Order',
      navActiveLink: 'insight',
      action: 'manage',
    },
  },
  {
    path: '/data-order/insight-pengiriman/order-retur',
    name: 'order-retur',
    component: () => import('@/views/pages/komship/order/InsightPengiriman/OrderChart.vue'),
    meta: {
      resource: 'Order',
      navActiveLink: 'insight',
      action: 'manage',
    },
  },
  {
    path: '/data-order/insight-pengiriman/order-dikirim/detail-kendala',
    name: 'order-detail-dikirim',
    component: () => import('@/views/pages/komship/order/InsightPengiriman/OrderDetail.vue'),
    meta: {
      resource: 'Order',
      navActiveLink: 'insight',
      action: 'manage',
    },
  },
  {
    path: '/data-order/insight-pengiriman/order-retur/detail-kendala',
    name: 'order-detail-retur',
    component: () => import('@/views/pages/komship/order/InsightPengiriman/OrderDetail.vue'),
    meta: {
      resource: 'Insight',
      navActiveLink: 'insight',
      action: 'manage',
    },
  },
  {
    path: '/data-order/ai',
    name: 'order-ai',
    component: () => import('@/views/pages/komship/order/OrderAi/List.vue'),
    meta: {
      resource: 'Order Ai',
      navActiveLink: 'Order',
      action: 'manage',
      name: 'order-ai',
      routeDetail: 'order-ai',
    },
  },
  {
    path: '/data-order/ai/:id',
    name: 'order-ai-detail',
    component: () => import('@/views/pages/komship/order/OrderAi/Detail.vue'),
    meta: {
      resource: 'Order Ai',
      navActiveLink: 'Order',
      action: 'manage',
    },
  },
  {
    path: '/data-order/ai/:id/edit',
    name: 'order-ai-edit',
    component: () => import('@/views/pages/komship/order/OrderAi/Edit.vue'),
    meta: {
      resource: 'Order Ai',
      navActiveLink: 'Order',
      action: 'manage',
    },
  },
]
